export function intersection<T>(...arrs: T[][]): Set<T> {
  const sets = arrs.map((arr) => new Set(arr));
  return sets.reduce((acc, x) => acc.intersection(x));
}
